import { Illustration, Text } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

import { type TbTestType } from "../types";

interface SuccessStepProps {
  requirementId: string;
  testType?: TbTestType;
  onDone: () => void;
}

export function SuccessStep(props: SuccessStepProps) {
  const { requirementId, testType, onDone } = props;

  useLogEffect(APP_V2_USER_EVENTS.VIEWED_TB_TEST_GUIDED_UPLOAD_SUCCESS_STEP, {
    requirementId,
    testType,
  });

  return (
    <>
      <DialogContent>
        <Stack spacing={6} sx={{ alignItems: "center", textAlign: "center", paddingTop: 8 }}>
          <Illustration type="document-review" />

          <Text variant="h3">Thank you for uploading your TB test</Text>

          <Text variant="body1" sx={(theme) => ({ color: theme.palette.text.secondary })}>
            Clipboard will review your upload over the next few days and get back to you shortly.
          </Text>
        </Stack>
      </DialogContent>

      <DialogFooter withShadow orientation="vertical">
        <Button fullWidth size="large" variant="contained" onClick={onDone}>
          Done
        </Button>
      </DialogFooter>
    </>
  );
}
